import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { visibleConcepts, approvedPrice } from "@/lib/concepts";
export function ConceptGrid({ segment, limit }: { segment?: string; limit?: number }) {
  const ranked = [
    "mingelklubben",
    "reaktionsmontern",
    "lagkampen-fem",
    "arcade-social",
    "motesloungen",
    "racing-grand-prix",
  ];
  const concepts = visibleConcepts()
    .sort((a, b) => {
      const rank = (slug: string) => (ranked.includes(slug) ? ranked.indexOf(slug) : 99);
      return rank(a.slug) - rank(b.slug);
    })
    .filter((c) => !segment || c.segment === segment)
    .slice(0, limit);
  return (
    <div className="concept-grid">
      {concepts.map((c) => (
        <article key={c.slug} className="concept-card">
          <Link to="/koncept/$slug" params={{ slug: c.slug }} className="concept-image">
            {c.image ? (
              <img src={c.image} alt={c.imageAlt} width="700" height="525" loading="lazy" />
            ) : c.slug === "mario-kart-cup" ? (
              <div className="mario-race-graphic" role="img" aria-label={c.imageAlt}>
                <span className="mario-controller" aria-hidden>
                  🏎️
                </span>
                <strong>Mario Kart Cup</strong>
                <small>Fysisk bilbana · två spelare per heat</small>
              </div>
            ) : (
              <div className="concept-image-fallback">Event Sverige</div>
            )}
            <span>{c.segment === "massa" ? "Mässa & aktivering" : "Företagsevent"}</span>
          </Link>
          <div className="concept-card-body">
            <p className="eyebrow">{c.durationLabel}</p>
            <h3>
              <Link to="/koncept/$slug" params={{ slug: c.slug }}>
                {c.name}
              </Link>
            </h3>
            <p>{c.tagline}</p>
            <strong className="block mt-4 text-sm">
              {approvedPrice(c) == null
                ? c.packagePending
                  ? "Pris fastställs efter kontroll"
                  : "Pris enligt offert"
                : `${approvedPrice(c)?.toLocaleString("sv-SE")} kr exkl. moms · transport tillkommer`}
            </strong>
            <small>{c.guests} · Stämningsljus ingår</small>
            <Link className="text-link" to="/koncept/$slug" params={{ slug: c.slug }}>
              Upplev konceptet <ArrowRight size={16} />
            </Link>
          </div>
        </article>
      ))}
      {concepts.length === 0 && (
        <div className="concept-panel">
          <h3>Vi hittar ert upplägg tillsammans</h3>
          <p>
            Berätta om datumet, platsen och gruppen. Vi tar fram ett förslag med aktiviteter, stämningsljus och
            bemanning.
          </p>
          <Link to="/forfragan" className="text-link">
            Beskriv ert event <ArrowRight size={16} />
          </Link>
        </div>
      )}
    </div>
  );
}
